import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

const LoginWrapper = ({ redirectTo = window.location.pathname }) => (
  <Box>
    <Button
      dataTestId="login-button"
      as="a"
      // @ts-expect-error: fix types
      href={Routes.network_login_path({
        params: {
          redirect_to: redirectTo,
        },
      })}
    >
      {I18n.t('layouts.homepage_network.header.login')}
    </Button>
  </Box>
);

export default LoginWrapper;
